module.exports = __webpack_public_path__ + "static/media/login.7d34ba2e.png";